const longFieldPattern = /(description|content|result|conclusion|comment|reason|minutes|actions|workContent|problems|correctiveAction|reviewComment|question|answer)/i;
const mediumFieldPattern = /(title|name|location|subject|supplier|responsibleParty|materialName|specification|project|tenderer|assignee)/i;
const narrowFieldPattern = /^(type|status|version|rank|priority|quantity|plannedPercent|actualPercent|durationDays)$/i;

export function isLongTextColumn(dataIndex?: string): boolean {
  return Boolean(dataIndex && longFieldPattern.test(dataIndex));
}

export function inferColumnWidth(dataIndex?: string, title?: string): number {
  if (!dataIndex) return 140;
  if (longFieldPattern.test(dataIndex)) return 280;
  if (mediumFieldPattern.test(dataIndex)) return 190;
  if (narrowFieldPattern.test(dataIndex)) return 110;
  if (/date|time|At$|deadline|expires/i.test(dataIndex)) return 170;
  if (/amount|price|budget|percent/i.test(dataIndex)) return 140;
  if ((title?.length ?? 0) >= 8) return 170;
  return 140;
}

export function displayCellValue(value: unknown): string {
  if (value == null || value === '') return '—';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

export function shouldUseCardLayout(dataIndexes: Array<string | undefined>): boolean {
  return dataIndexes.length >= 7 || dataIndexes.filter((value) => isLongTextColumn(value)).length >= 2;
}
